import axios from 'axios';
import googleAnalyticsClient from '../common/google_analytics/ajax_handling';
import karteErrorClient from '../common/karte/error';

class StoresBulkIndex {
  getStores(storeIds: Array<string>) {
    type storeAttributes = { id: number, name: string };
    type resultStore = { attributes: storeAttributes };
    type resultStores = { data: Array<resultStore> };

    const token = this.getCsrfToken();

    const getStoresTotalCount = this.getStoresTotalCount(storeIds);

    const getStoresInParallel = (storeIds: Array<string>, perPage: number, page: number) => {
      return new Promise(function(resolve, reject){
        axios
          .post<resultStores>('/staff/api/stores/bulk_index', { store_ids: storeIds, per_page: perPage, page: page }, {
            headers: {
              'X-CSRF-Token': token
            }
          })
          .then(response => {
            const data = response.data;
            resolve(data);
          }).catch(error => {
            // エラー処理
            reject(error);
          });
      });
    }

    return new Promise(function(resolve, reject){
      getStoresTotalCount.then((storesTotalCount) => {
        const parallelProcessingNum = 5;
        const perPage = Math.ceil((storesTotalCount as number)/parallelProcessingNum);
        var promiseArray = new Array;
        for (var i=0; (i*perPage)<(storesTotalCount as number); i++){
          const page = i+1;
          promiseArray.push(getStoresInParallel(storeIds, perPage, page));
        }
        Promise.all(promiseArray).then((datas) => {
          var resultArray = new Array;
          [].forEach.call(datas, data => {
            [].forEach.call((data as resultStores).data, store => {
              resultArray = resultArray.concat(store);
            });
          })
          resolve({ data: resultArray })
        }).catch(error => {
          // 全体の中でエラーが発生した
          const errorPath = '/staff/api/stores/bulk_index';
          const errorMessage = '店舗一覧取得でエラーが発生';
          const el = document.querySelector<HTMLElement>('#staff_infomation');
          const staffId = el?.dataset.staffId;
          const now = el?.dataset.now;

          // エラーイベントを送信 (GA)
          if(staffId && now) {
            googleAnalyticsClient.error({
              time: now,
              path: errorPath,
              staffId: staffId,
              message: errorMessage
            });
          }

          // エラーイベントを送信 (KARTE)
          karteErrorClient.error({
            path: errorPath,
            message: errorMessage
          });

          reject(error);
        });;
      });
    });
  }

  getStoresTotalCount(storeIds: Array<string>) {
    type result = { data: { total_count: number } };
    const token = this.getCsrfToken();

    return new Promise(function(resolve, reject){
      axios
        .post<result>('/staff/api/stores/total_count', { store_ids: storeIds }, {
          headers: {
            'X-CSRF-Token': token
          }
        })
        .then(response => {
          const data = response.data;
          resolve(data.data.total_count);
        }).catch(error => {
          // エラー処理
          reject(error);
        });
    });
  }

  getCsrfToken() {
    return (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
  }
}

export default StoresBulkIndex;
